import styles from "./shopcategories.module.css";
import { Loader } from "../../shared/index";
import { Products } from "../index";
import { Link } from "react-router-dom";
const ShopProducts = ({
  products = [],
  isPending,
  isError,
  error,
  wishItems = [],
  isWishListPending,
  hasMore,
  isFetching,
  lastItemRef,
}) => {
  if (isPending && products.length === 0) {
    return (
      <div className={styles.productsLoaderWrapper}>
        <Loader />
      </div>
    );
  }
  if (isError && !isPending) {
    return (
      <div className={styles.errorWrapper}>
        <p className={styles.errorMessage}>
          No Products Found for This Category
        </p>

        <Link to="/shop" className={styles.continueShoppingBtn}>
          Continue Shopping
        </Link>
      </div>
    );
  }
  if (!isPending && products.length === 0) {
    console.log("FINAL PRODUCTS:", products);
    return (
      <div className={styles.noProducts}>
        <p>No products found for this category.</p>
        <Link to="/shop" className={styles.continueShoppingBtn}>
          Continue shopping
        </Link>
      </div>
    );
  }
  return (
    <>

      <Products
        title=""
        products={products}
        category=""
        variant="grid"
        wishItems={wishItems}
        isWishListPending={isWishListPending}
        lastItemRef={lastItemRef}
      />
      {isFetching && hasMore && (
        <div className={styles.loaderWrapper}>
          <Loader title="Loading more products..." />
        </div>
      )}
    </>
  );
};
export default ShopProducts;